module.exports = __webpack_public_path__ + "static/media/p11.f19100bc.csv";